import { SeoItemList } from "@types";
import sanitizeHtml from "sanitize-html";
import { CMSFaqProps, FaqAccordionContent, FaqTextContent } from "types/CMSFaqProps";

export const mapFaqSEO = (faqComponents: CMSFaqProps[]): SeoItemList => {
    const faqs: SeoItemList = [];

    faqComponents?.forEach((faqComponent) => {
        //Collect Accordion FAQs
        if (faqComponent?.accordion && faqComponent?.accordion_content?.length) {
            faqComponent?.accordion_content?.forEach(({ accordion }: FaqAccordionContent) => {
                accordion?.panes.forEach(({ pane }) => {
                    faqs.push({
                        "@type": "Question",
                        name: sanitizeHtml(pane?.question, { allowedTags: [] }),
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: sanitizeHtml(pane?.answer, { allowedTags: [] }),
                        },
                    });
                });
            });
        }

        //Collect Text FAQs
        if (!faqComponent?.accordion && faqComponent?.text_content?.length) {
            faqComponent?.text_content?.forEach(({ text }: FaqTextContent) => {
                faqs.push({
                    "@type": "Question",
                    name: sanitizeHtml(text?.question, { allowedTags: [] }),
                    acceptedAnswer: {
                        "@type": "Answer",
                        text: sanitizeHtml(text?.answer, { allowedTags: [] }),
                    },
                });
            });
        }
    });
    return faqs;
};
